import connection from "./connection";
import axios from 'axios';
import { AssetActivityControlRequest } from "@gtpl/shared-models/common-models";
import { DeviceRequest } from '@gtpl/shared-models/warehouse-management';

export class JobManagementApiService {
    URL = connection.DEPLOY_URL + '/assent-mgnt-jobs';

    async triggerJobForAssetActivity(reqObj: AssetActivityControlRequest): Promise<boolean> {

        return await axios.post(this.URL + '/triggerJobForAssetActivity', reqObj)
            .then(res => {
                return res.data
            })
    }

    async controlSmartPlug() {
        return await axios.post(this.URL + '/controlSmartPlug')
        .then(res => {
            return res.data
        })
    }



    async triggerToControlTheBulb(req:DeviceRequest) {
        return await axios.put('http://192.168.0.124/api/'+req.userName+'/'+req.deviceName+'/'+req.bulbId+'/state',req) 
            .then(res=>{
                return res.data
            })
    }

}